export const ROUTES = {
  MEMBERSHIP_STEPS: '/membership-steps',
  MEMBERSHIP_DOMAINS: '/membership-steps/domains',
  UPGRADE: '/prorogate-or-upgrade/',
  HOME: '/',
  TERMS_OF_SERVICE: 'https://mizfa.tools/terms-of-service/',
} as const;

export const MESSAGES = {
  INTRO_CODE_SUCCESS: 'کدمعرف با موفقیت اعمال شد',
  INTRO_CODE_INVALID: 'کدمعرف معتبر نمیباشد.',
  INVOICE_ERROR: 'خطا در دریافت اطلاعات فاکتور',
  PAYMENT_ERROR: 'خطا در انتقال به صفحه پرداخت',
  TERMS_NOT_READ: 'شرایط استفاده از خدمات رو مطالعه نکردید!',
  INVOICE_INFO_REQUIRED: 'برای چاپ پیش‌فاکتور اطلاعات لازم رو اضافه کنید.',
} as const;

export const ERROR_CODES = {
  INTRO_CODE_INVALID: 60001,
  INVOICE_INFO_MISSING: 60002,
} as const;
